import React from 'react'
import PropTypes from 'react-proptypes'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import compose from 'recompose/compose'
import { FormHelperText } from 'material-ui/Form'
import { InputLabel } from 'material-ui/Input'
import DialogCurrencySelector from 'components/DialogCurrencySelector'

const styles = {}

class CurrencySelector extends React.Component {
  state = {
    open: false,
  }

  handleChange = c => {
    this.props.input.onChange(c)
  }

  openSelector = () => {
    this.setState({ open: true })
  }

  handleRequestClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { open } = this.state
    const { input, meta, label, currencies } = this.props
    return (
      <div>
        <InputLabel>{label}</InputLabel>
        <Button onClick={this.openSelector} color="primary">
          {input.value ? <div>{input.value}</div> : 'Select a Currency'}
        </Button>
        {meta.error &&
        meta.touched && <FormHelperText error>{meta.error}</FormHelperText>}
        <DialogCurrencySelector
          currencies={currencies}
          open={open}
          onChange={this.handleChange}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    )
  }
}

CurrencySelector.propTypes = {
  currencies: PropTypes.array,
}

export default compose(withStyles(styles))(CurrencySelector)



// WEBPACK FOOTER //
// ./src/components/fields/CurrencySelector.js